module.exports = __webpack_public_path__ + "img/L1_zoom.5013d99c.svg";